// extracted by mini-css-extract-plugin
export default {"topbar":"Topbar_topbar__t+Txi","logo":"Topbar_logo__dxilz","avatarWrapper":"Topbar_avatarWrapper__WDM-+"};